// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.secondary-button {
    padding: calc(var(--space-half) + var(--space-eighth)) calc(var(--space-x2) + var(--space-half) + var(--space-eighth));
    font-size: var(--space);/* 16px */
    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    background-color: var(--white-color);
    mix-blend-mode: normal;
    border: 2px solid var(--new-green-color);
    color: var(--new-green-color);
    box-sizing: border-box;
}
.secondary-button:focus {
    background-color: var(--new-green-color);
    color: var(--white-color);
}
.secondary-button:hover {
    background-color: var(--new-green-color);
    color: var(--white-color);
}
.secondary-button:active {
    background-color: var(--new-green-color);
    color: var(--white-color);
}
.secondary-button:disabled {
    opacity: 0.64;   
}

.secondary-button.red {
    background-color: var(--white-color);
    mix-blend-mode: normal;
    border: 2px solid var(--error-color);
    color: var(--error-color);
    box-sizing: border-box;
}
.secondary-button.red:focus {
    background-color: var(--error-color);
    color: var(--white-color);
}
.secondary-button.red:hover {
    background-color: var(--error-color);
    color: var(--white-color);
}
.secondary-button.red:active {
    background-color: var(--error-color);
    color: var(--white-color);
}
.secondary-button.red:disabled {
    opacity: 0.64;   
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/secondary-button/SecondaryButtonComponent.styles.css"],"names":[],"mappings":";AACA;IACI,sHAAsH;IACtH,uBAAuB,CAAC,SAAS;IACjC,2DAA2D,CAAC,SAAS;IACrE,oCAAoC;IACpC,sBAAsB;IACtB,wCAAwC;IACxC,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB","sourcesContent":["\n.secondary-button {\n    padding: calc(var(--space-half) + var(--space-eighth)) calc(var(--space-x2) + var(--space-half) + var(--space-eighth));\n    font-size: var(--space);/* 16px */\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    background-color: var(--white-color);\n    mix-blend-mode: normal;\n    border: 2px solid var(--new-green-color);\n    color: var(--new-green-color);\n    box-sizing: border-box;\n}\n.secondary-button:focus {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n.secondary-button:hover {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n.secondary-button:active {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n.secondary-button:disabled {\n    opacity: 0.64;   \n}\n\n.secondary-button.red {\n    background-color: var(--white-color);\n    mix-blend-mode: normal;\n    border: 2px solid var(--error-color);\n    color: var(--error-color);\n    box-sizing: border-box;\n}\n.secondary-button.red:focus {\n    background-color: var(--error-color);\n    color: var(--white-color);\n}\n.secondary-button.red:hover {\n    background-color: var(--error-color);\n    color: var(--white-color);\n}\n.secondary-button.red:active {\n    background-color: var(--error-color);\n    color: var(--white-color);\n}\n.secondary-button.red:disabled {\n    opacity: 0.64;   \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
